import APIClient from '@/shared/http/clients/api'

const APIBusiness = process.env.APIBaseURLBusinessCommon
const resourceName = 'TermoAnexoLog'

// Tasks 030/046: o back so devolve lote da empresa da tela, e so se a conta pode usar essa empresa.
const GetByName = (name, empresaId, data = {}, config = {}) => APIClient.get(`${APIBusiness}/${resourceName}/GetByName/${name}/${empresaId}`, data, config)
const GetByLote = (lote, empresaId, data = {}, config = {}) => APIClient.get(`${APIBusiness}/${resourceName}/GetByLote/${lote}/${empresaId}`, data, config)
const GetAll = (empresaId, data = {}, config = {}) => APIClient.get(`${APIBusiness}/${resourceName}/GetAll/${empresaId}`, data, config)

const TermlogAttachedRepository = {
  GetByName,
  GetByLote,
  GetAll
}

export default TermlogAttachedRepository



// WEBPACK FOOTER //
// ./src/shared/http/repositories/business/termlogattached.js